import RsrcBlueprintAnalyzer from "./RsrcBlueprintAnalyzer.js";
export default {
  id: 'rsrc.BlueprintAnalyzer',
  sort: -100,
  init: async molten => {
    const bps = [{
      id: 'rsrcBlueprintId',
      alias: 'rsrc',
      name: 'Resource'
    }];
    const ba = new RsrcBlueprintAnalyzer({
      blueprints: bps,
      molten
    });
    await ba.install();
  }
};